import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IAppointment } from '../../models/appointment.interface';
import { ActionClick } from '../../models/data-table.interface';

@Component({
    standalone: false,
    selector: 'cva-appointment-card-view',
    templateUrl: './appointment-card-view.component.html',
    styleUrl: './appointment-card-view.component.scss',
    
})
export class AppointmentCardViewComponent {
  @Input() appointment!: IAppointment;
  @Output() actionClick: EventEmitter<ActionClick<IAppointment>> = new EventEmitter<ActionClick<IAppointment>>();

  constructor() { }

  onAction(event: MouseEvent, action: 'edit' | 'delete') {
    event.stopPropagation();
    if (action === 'delete' && (this.appointment?.hasTranscription || this.appointment?.pastAppointment)) {
      return;
    }
    this.actionClick.emit({ rowData: this.appointment, action });
  }
}
